// assets/Stimuli/index.ts
// ⚠️ généré automatiquement
import geometrie_diagonal1_blanc_trait from './geometrie_diagonal1_blanc_trait.png';
import geometrie_diagonal1_bleu_trait from './geometrie_diagonal1_bleu_trait.png';
import geometrie_diagonal1_jaune_trait from './geometrie_diagonal1_jaune_trait.png';
import geometrie_diagonal1_noir_trait from './geometrie_diagonal1_noir_trait.png';
import geometrie_diagonal1_orange_trait from './geometrie_diagonal1_orange_trait.png';
import geometrie_diagonal1_rose_trait from './geometrie_diagonal1_rose_trait.png';
import geometrie_diagonal1_rouge_trait from './geometrie_diagonal1_rouge_trait.png';
import geometrie_diagonal1_vert_trait from './geometrie_diagonal1_vert_trait.png';
import geometrie_diagonal1_violet_trait from './geometrie_diagonal1_violet_trait.png';
import geometrie_diagonal2_blanc_trait from './geometrie_diagonal2_blanc_trait.png';
import geometrie_diagonal2_bleu_trait from './geometrie_diagonal2_bleu_trait.png';
import geometrie_diagonal2_jaune_trait from './geometrie_diagonal2_jaune_trait.png';
import geometrie_diagonal2_noir_trait from './geometrie_diagonal2_noir_trait.png';
import geometrie_diagonal2_orange_trait from './geometrie_diagonal2_orange_trait.png';
import geometrie_diagonal2_rose_trait from './geometrie_diagonal2_rose_trait.png';
import geometrie_diagonal2_rouge_trait from './geometrie_diagonal2_rouge_trait.png';
import geometrie_diagonal2_vert_trait from './geometrie_diagonal2_vert_trait.png';
import geometrie_diagonal2_violet_trait from './geometrie_diagonal2_violet_trait.png';
import geometrie_horizontal_blanc_trait from './geometrie_horizontal_blanc_trait.png';
import geometrie_horizontal_bleu_trait from './geometrie_horizontal_bleu_trait.png';
import geometrie_horizontal_jaune_trait from './geometrie_horizontal_jaune_trait.png';
import geometrie_horizontal_noir_trait from './geometrie_horizontal_noir_trait.png';
import geometrie_horizontal_orange_trait from './geometrie_horizontal_orange_trait.png';
import geometrie_horizontal_rose_trait from './geometrie_horizontal_rose_trait.png';
import geometrie_horizontal_rouge_trait from './geometrie_horizontal_rouge_trait.png';
import geometrie_horizontal_vert_trait from './geometrie_horizontal_vert_trait.png';
import geometrie_horizontal_violet_trait from './geometrie_horizontal_violet_trait.png';
import geometrie_plein_blanc_carre from './geometrie_plein_blanc_carre.png';
import geometrie_plein_blanc_etoile from './geometrie_plein_blanc_etoile.png';
import geometrie_plein_blanc_losange from './geometrie_plein_blanc_losange.png';
import geometrie_plein_blanc_rond from './geometrie_plein_blanc_rond.png';
import geometrie_plein_blanc_triangle from './geometrie_plein_blanc_triangle.png';
import geometrie_plein_bleu_carre from './geometrie_plein_bleu_carre.png';
import geometrie_plein_bleu_etoile from './geometrie_plein_bleu_etoile.png';
import geometrie_plein_bleu_losange from './geometrie_plein_bleu_losange.png';
import geometrie_plein_bleu_rond from './geometrie_plein_bleu_rond.png';
import geometrie_plein_bleu_triangle from './geometrie_plein_bleu_triangle.png';
import geometrie_plein_jaune_carre from './geometrie_plein_jaune_carre.png';
import geometrie_plein_jaune_etoile from './geometrie_plein_jaune_etoile.png';
import geometrie_plein_jaune_losange from './geometrie_plein_jaune_losange.png';
import geometrie_plein_jaune_rond from './geometrie_plein_jaune_rond.png';
import geometrie_plein_jaune_triangle from './geometrie_plein_jaune_triangle.png';
import geometrie_plein_noir_carre from './geometrie_plein_noir_carre.png';
import geometrie_plein_noir_etoile from './geometrie_plein_noir_etoile.png';
import geometrie_plein_noir_losange from './geometrie_plein_noir_losange.png';
import geometrie_plein_noir_rond from './geometrie_plein_noir_rond.png';
import geometrie_plein_noir_triangle from './geometrie_plein_noir_triangle.png';
import geometrie_plein_orange_carre from './geometrie_plein_orange_carre.png';
import geometrie_plein_orange_etoile from './geometrie_plein_orange_etoile.png';
import geometrie_plein_orange_losange from './geometrie_plein_orange_losange.png';
import geometrie_plein_orange_rond from './geometrie_plein_orange_rond.png';
import geometrie_plein_orange_triangle from './geometrie_plein_orange_triangle.png';
import geometrie_plein_rose_carre from './geometrie_plein_rose_carre.png';
import geometrie_plein_rose_etoile from './geometrie_plein_rose_etoile.png';
import geometrie_plein_rose_losange from './geometrie_plein_rose_losange.png';
import geometrie_plein_rose_rond from './geometrie_plein_rose_rond.png';
import geometrie_plein_rose_triangle from './geometrie_plein_rose_triangle.png';
import geometrie_plein_rouge_carre from './geometrie_plein_rouge_carre.png';
import geometrie_plein_rouge_etoile from './geometrie_plein_rouge_etoile.png';
import geometrie_plein_rouge_losange from './geometrie_plein_rouge_losange.png';
import geometrie_plein_rouge_rond from './geometrie_plein_rouge_rond.png';
import geometrie_plein_rouge_triangle from './geometrie_plein_rouge_triangle.png';
import geometrie_plein_vert_carre from './geometrie_plein_vert_carre.png';
import geometrie_plein_vert_etoile from './geometrie_plein_vert_etoile.png';
import geometrie_plein_vert_losange from './geometrie_plein_vert_losange.png';
import geometrie_plein_vert_rond from './geometrie_plein_vert_rond.png';
import geometrie_plein_vert_triangle from './geometrie_plein_vert_triangle.png';
import geometrie_plein_violet_carre from './geometrie_plein_violet_carre.png';
import geometrie_plein_violet_etoile from './geometrie_plein_violet_etoile.png';
import geometrie_plein_violet_losange from './geometrie_plein_violet_losange.png';
import geometrie_plein_violet_rond from './geometrie_plein_violet_rond.png';
import geometrie_plein_violet_triangle from './geometrie_plein_violet_triangle.png';
import geometrie_vertical_blanc_trait from './geometrie_vertical_blanc_trait.png';
import geometrie_vertical_bleu_trait from './geometrie_vertical_bleu_trait.png';
import geometrie_vertical_jaune_trait from './geometrie_vertical_jaune_trait.png';
import geometrie_vertical_noir_trait from './geometrie_vertical_noir_trait.png';
import geometrie_vertical_orange_trait from './geometrie_vertical_orange_trait.png';
import geometrie_vertical_rose_trait from './geometrie_vertical_rose_trait.png';
import geometrie_vertical_rouge_trait from './geometrie_vertical_rouge_trait.png';
import geometrie_vertical_vert_trait from './geometrie_vertical_vert_trait.png';
import geometrie_vertical_violet_trait from './geometrie_vertical_violet_trait.png';
import geometrie_vide_blanc_etoile from './geometrie_vide_blanc_etoile.png';
import geometrie_vide_blanc_carre from './geometrie_vide_blanc_carre.png';
import geometrie_vide_blanc_losange from './geometrie_vide_blanc_losange.png';
import geometrie_vide_blanc_rond from './geometrie_vide_blanc_rond.png';
import geometrie_vide_blanc_soleil from './geometrie_vide_blanc_soleil.png';
import geometrie_vide_blanc_triangle from './geometrie_vide_blanc_triangle.png';
import geometrie_vide_bleu_carre from './geometrie_vide_bleu_carre.png';
import geometrie_vide_bleu_etoile from './geometrie_vide_bleu_etoile.png';
import geometrie_vide_bleu_losange from './geometrie_vide_bleu_losange.png';
import geometrie_vide_bleu_rond from './geometrie_vide_bleu_rond.png';
import geometrie_vide_bleu_soleil from './geometrie_vide_bleu_soleil.png';
import geometrie_vide_bleu_triangle from './geometrie_vide_bleu_triangle.png';
import geometrie_vide_jaune_carre from './geometrie_vide_jaune_carre.png';
import geometrie_vide_jaune_etoile from './geometrie_vide_jaune_etoile.png';
import geometrie_vide_jaune_losange from './geometrie_vide_jaune_losange.png';
import geometrie_vide_jaune_rond from './geometrie_vide_jaune_rond.png';
import geometrie_vide_jaune_soleil from './geometrie_vide_jaune_soleil.png';
import geometrie_vide_jaune_triangle from './geometrie_vide_jaune_triangle.png';
import geometrie_vide_noir_carre from './geometrie_vide_noir_carre.png';
import geometrie_vide_noir_etoile from './geometrie_vide_noir_etoile.png';
import geometrie_vide_noir_losange from './geometrie_vide_noir_losange.png';
import geometrie_vide_noir_rond from './geometrie_vide_noir_rond.png';
import geometrie_vide_noir_soleil from './geometrie_vide_noir_soleil.png';
import geometrie_vide_noir_triangle from './geometrie_vide_noir_triangle.png';
import geometrie_vide_orange_carre from './geometrie_vide_orange_carre.png';
import geometrie_vide_orange_etoile from './geometrie_vide_orange_etoile.png';
import geometrie_vide_orange_losange from './geometrie_vide_orange_losange.png';
import geometrie_vide_orange_rond from './geometrie_vide_orange_rond.png';
import geometrie_vide_orange_soleil from './geometrie_vide_orange_soleil.png';
import geometrie_vide_orange_triangle from './geometrie_vide_orange_triangle.png';
import geometrie_vide_rose_carre from './geometrie_vide_rose_carre.png';
import geometrie_vide_rose_etoile from './geometrie_vide_rose_etoile.png';
import geometrie_vide_rose_losange from './geometrie_vide_rose_losange.png';
import geometrie_vide_rose_rond from './geometrie_vide_rose_rond.png';
import geometrie_vide_rose_soleil from './geometrie_vide_rose_soleil.png';
import geometrie_vide_rose_triangle from './geometrie_vide_rose_triangle.png';
import geometrie_vide_rouge_carre from './geometrie_vide_rouge_carre.png';
import geometrie_vide_rouge_etoile from './geometrie_vide_rouge_etoile.png';
import geometrie_vide_rouge_losange from './geometrie_vide_rouge_losange.png';
import geometrie_vide_rouge_rond from './geometrie_vide_rouge_rond.png';
import geometrie_vide_rouge_soleil from './geometrie_vide_rouge_soleil.png';
import geometrie_vide_rouge_triangle from './geometrie_vide_rouge_triangle.png';
import geometrie_vide_vert_carre from './geometrie_vide_vert_carre.png';
import geometrie_vide_vert_etoile from './geometrie_vide_vert_etoile.png';
import geometrie_vide_vert_losange from './geometrie_vide_vert_losange.png';
import geometrie_vide_vert_rond from './geometrie_vide_vert_rond.png';
import geometrie_vide_vert_soleil from './geometrie_vide_vert_soleil.png';
import geometrie_vide_vert_triangle from './geometrie_vide_vert_triangle.png';
import geometrie_vide_violet_carre from './geometrie_vide_violet_carre.png';
import geometrie_vide_violet_etoile from './geometrie_vide_violet_etoile.png';
import geometrie_vide_violet_losange from './geometrie_vide_violet_losange.png';
import geometrie_vide_violet_rond from './geometrie_vide_violet_rond.png';
import geometrie_vide_violet_soleil from './geometrie_vide_violet_soleil.png';
import geometrie_vide_violet_triangle from './geometrie_vide_violet_triangle.png';
import objet_fixe_couleur_abeille from './objet_fixe_couleur_abeille.png';
import objet_fixe_couleur_agneau from './objet_fixe_couleur_agneau.png';
import objet_fixe_couleur_altere from './objet_fixe_couleur_altere.png';
import objet_fixe_couleur_ananas from './objet_fixe_couleur_ananas.png';
import objet_fixe_couleur_ananaslunettes from './objet_fixe_couleur_ananaslunettes.png';
import objet_fixe_couleur_appareilphoto from './objet_fixe_couleur_appareilphoto.png';
import objet_fixe_couleur_asdepique from './objet_fixe_couleur_asdepique.png';
import objet_fixe_couleur_badminton from './objet_fixe_couleur_badminton.png';
import objet_fixe_couleur_baleine from './objet_fixe_couleur_baleine.png';
import objet_fixe_couleur_ballebaseball from './objet_fixe_couleur_ballebaseball.png';
import objet_fixe_couleur_balletennis from './objet_fixe_couleur_balletennis.png';
import objet_fixe_couleur_ballonbasket from './objet_fixe_couleur_ballonbasket.png';
import objet_fixe_couleur_biscuit1 from './objet_fixe_couleur_biscuit1.png';
import objet_fixe_couleur_biscuit2 from './objet_fixe_couleur_biscuit2.png';
import objet_fixe_couleur_cartes from './objet_fixe_couleur_cartes.png';
import objet_fixe_couleur_casquemoto from './objet_fixe_couleur_casquemoto.png';
import objet_fixe_couleur_chapeaupaille from './objet_fixe_couleur_chapeaupaille.png';
import objet_fixe_couleur_chat from './objet_fixe_couleur_chat.png';
import objet_fixe_couleur_chaussuresport from './objet_fixe_couleur_chaussuresport.png';
import objet_fixe_couleur_chevreau from './objet_fixe_couleur_chevreau.png';
import objet_fixe_couleur_chientete from './objet_fixe_couleur_chientete.png';
import objet_fixe_couleur_citron from './objet_fixe_couleur_citron.png';
import objet_fixe_couleur_coeur from './objet_fixe_couleur_coeur.png';
import objet_fixe_couleur_croissant from './objet_fixe_couleur_croissant.png';
import objet_fixe_couleur_dragon from './objet_fixe_couleur_dragon.png';
import objet_fixe_couleur_etoiledemer from './objet_fixe_couleur_etoiledemer.png';
import objet_fixe_couleur_evantail from './objet_fixe_couleur_evantail.png';
import objet_fixe_couleur_fleur from './objet_fixe_couleur_fleur.png';
import objet_fixe_couleur_fleurscerisier from './objet_fixe_couleur_fleurscerisier.png';
import objet_fixe_couleur_fraise from './objet_fixe_couleur_fraise.png';
import objet_fixe_couleur_gantboxe from './objet_fixe_couleur_gantboxe.png';
import objet_fixe_couleur_grenouille from './objet_fixe_couleur_grenouille.png';
import objet_fixe_couleur_jeuenfant from './objet_fixe_couleur_jeuenfant.png';
import objet_fixe_couleur_kiwi from './objet_fixe_couleur_kiwi.png';
import objet_fixe_couleur_lion from './objet_fixe_couleur_lion.png';
import objet_fixe_couleur_maillotbain from './objet_fixe_couleur_maillotbain.png';
import objet_fixe_couleur_maincle from './objet_fixe_couleur_maincle.png';
import objet_fixe_couleur_manchot from './objet_fixe_couleur_manchot.png';
import objet_fixe_couleur_manette from './objet_fixe_couleur_manette.png';
import objet_fixe_couleur_minion from './objet_fixe_couleur_minion.png';
import objet_fixe_couleur_monstre1 from './objet_fixe_couleur_monstre1.png';
import objet_fixe_couleur_monstre2 from './objet_fixe_couleur_monstre2.png';
import objet_fixe_couleur_mouton from './objet_fixe_couleur_mouton.png';
import objet_fixe_couleur_oeil from './objet_fixe_couleur_oeil.png';
import objet_fixe_couleur_orange from './objet_fixe_couleur_orange.png';
import objet_fixe_couleur_ourstete from './objet_fixe_couleur_ourstete.png';
import objet_fixe_couleur_palmier from './objet_fixe_couleur_palmier.png';
import objet_fixe_couleur_panneauparis from './objet_fixe_couleur_panneauparis.png';
import objet_fixe_couleur_papillon from './objet_fixe_couleur_papillon.png';
import objet_fixe_couleur_parasol from './objet_fixe_couleur_parasol.png';
import objet_fixe_couleur_perroquet from './objet_fixe_couleur_perroquet.png';
import objet_fixe_couleur_pieuvre from './objet_fixe_couleur_pieuvre.png';
import objet_fixe_couleur_plantepot from './objet_fixe_couleur_plantepot.png';
import objet_fixe_couleur_raquette from './objet_fixe_couleur_raquette.png';
import objet_fixe_couleur_renard from './objet_fixe_couleur_renard.png';
import objet_fixe_couleur_rougealevres from './objet_fixe_couleur_rougealevres.png';
import objet_fixe_couleur_seau from './objet_fixe_couleur_seau.png';
import objet_fixe_couleur_serpent from './objet_fixe_couleur_serpent.png';
import objet_fixe_couleur_short from './objet_fixe_couleur_short.png';
import objet_fixe_couleur_television from './objet_fixe_couleur_television.png';
import objet_fixe_couleur_tongs from './objet_fixe_couleur_tongs.png';
import objet_fixe_couleur_tortue from './objet_fixe_couleur_tortue.png';
import objet_fixe_couleur_vache from './objet_fixe_couleur_vache.png';
import objet_fixe_couleur_voiture from './objet_fixe_couleur_voiture.png';
import objet_fixe_nb_avion from './objet_fixe_nb_avion.gif';
import objet_fixe_nb_baguettemagique from './objet_fixe_nb_baguettemagique.gif';
import objet_fixe_nb_chat from './objet_fixe_nb_chat.gif';
import objet_fixe_nb_drapeau from './objet_fixe_nb_drapeau.png';
import objet_fixe_noir_empreintepatte from './objet_fixe_noir_empreintepatte.png';
import objet_fixe_nb_fusee from './objet_fixe_nb_fusee.gif';
import objet_fixe_nb_loup from './objet_fixe_nb_loup.png';
import objet_fixe_nb_marguerite from './objet_fixe_nb_marguerite.gif';
import objet_fixe_nb_montagnes from './objet_fixe_nb_montagnes.png';
import objet_fixe_nb_nuage2 from './objet_fixe_nb_nuage.gif';
import objet_fixe_nb_nuage from './objet_fixe_nb_nuage.png';
import objet_fixe_nb_nuagelunettes from './objet_fixe_nb_nuagelunettes.png';
import objet_fixe_nb_robinet from './objet_fixe_nb_robinet.gif';
import objet_mouvement_couleur_abeilledessus from './objet_mouvement_couleur_abeilledessus.gif';
import objet_mouvement_couleur_abeillefleur1 from './objet_mouvement_couleur_abeillefleur1.gif';
import objet_mouvement_couleur_abeillefleur2 from './objet_mouvement_couleur_abeillefleur2.gif';
import objet_mouvement_couleur_abeillemiel from './objet_mouvement_couleur_abeillemiel.gif';
import objet_mouvement_couleur_abeilleruche from './objet_mouvement_couleur_abeilleruche.gif';
import objet_mouvement_couleur_abeillevol from './objet_mouvement_couleur_abeillevol.gif';
import objet_mouvement_couleur_ampoule from './objet_mouvement_couleur_ampoule.gif';
import objet_mouvement_couleur_antenne from './objet_mouvement_couleur_antenne.gif';
import objet_mouvement_couleur_antilope from './objet_mouvement_couleur_antilope.gif';
import objet_mouvement_couleur_appareilphoto1 from './objet_mouvement_couleur_appareilphoto1.gif';
import objet_mouvement_couleur_appareilphoto2 from './objet_mouvement_couleur_appareilphoto2.gif';
import objet_mouvement_couleur_appareilphoto3 from './objet_mouvement_couleur_appareilphoto3.gif';
import objet_mouvement_couleur_arobase from './objet_mouvement_couleur_arobase.gif';
import objet_mouvement_couleur_asterisque1 from './objet_mouvement_couleur_asterisque1.gif';
import objet_mouvement_couleur_asterisque2 from './objet_mouvement_couleur_asterisque2.gif';
import objet_mouvement_couleur_ballon from './objet_mouvement_couleur_ballon.gif';
import objet_mouvement_couleur_ballonbasket1 from './objet_mouvement_couleur_ballonbasket1.gif';
import objet_mouvement_couleur_ballonbasket2 from './objet_mouvement_couleur_ballonbasket2.gif';
import objet_mouvement_couleur_bananes from './objet_mouvement_couleur_bananes.gif';
import objet_mouvement_couleur_bananier from './objet_mouvement_couleur_bananier.gif';
import objet_mouvement_couleur_bateau1 from './objet_mouvement_couleur_bateau1.gif';
import objet_mouvement_couleur_bateau2 from './objet_mouvement_couleur_bateau2.gif';
import objet_mouvement_couleur_bateau3 from './objet_mouvement_couleur_bateau3.gif';
import objet_mouvement_couleur_bonhommeneige from './objet_mouvement_couleur_bonhommeneige.gif';
import objet_mouvement_couleur_bourdon from './objet_mouvement_couleur_bourdon.gif';
import objet_mouvement_couleur_cactus from './objet_mouvement_couleur_cactus.gif';
import objet_mouvement_couleur_capitaine from './objet_mouvement_couleur_capitaine.gif';
import objet_mouvement_couleur_cartes from './objet_mouvement_couleur_cartes.gif';
import objet_mouvement_couleur_cd1 from './objet_mouvement_couleur_cd1.gif';
import objet_mouvement_couleur_cd2 from './objet_mouvement_couleur_cd2.gif';
import objet_mouvement_couleur_cd3 from './objet_mouvement_couleur_cd3.gif';
import objet_mouvement_couleur_champignons from './objet_mouvement_couleur_champignons.gif';
import objet_mouvement_couleur_chauvesouris from './objet_mouvement_couleur_chauvesouris.gif';
import objet_mouvement_couleur_cheval from './objet_mouvement_couleur_cheval.gif';
import objet_mouvement_couleur_chien from './objet_mouvement_couleur_chien.gif';
import objet_mouvement_couleur_ciseaux from './objet_mouvement_couleur_ciseaux.gif';
import objet_mouvement_couleur_citron from './objet_mouvement_couleur_citron.gif';
import objet_mouvement_couleur_citrouille from './objet_mouvement_couleur_citrouille.gif';
import objet_mouvement_couleur_cle from './objet_mouvement_couleur_cle.gif';
import objet_mouvement_couleur_coq from './objet_mouvement_couleur_coq.gif';
import objet_mouvement_couleur_coquille from './objet_mouvement_couleur_coquille.gif';
import objet_mouvement_couleur_cornetglaces from './objet_mouvement_couleur_cornetglaces.gif';
import objet_mouvement_couleur_crabe from './objet_mouvement_couleur_crabe.gif';
import objet_mouvement_couleur_crayons1 from './objet_mouvement_couleur_crayons1.gif';
import objet_mouvement_couleur_crayons2 from './objet_mouvement_couleur_crayons2.gif';
import objet_mouvement_couleur_crayons3 from './objet_mouvement_couleur_crayons3.gif';
import objet_mouvement_couleur_cygne from './objet_mouvement_couleur_cygne.gif';
import objet_mouvement_couleur_danse from './objet_mouvement_couleur_danse.gif';
import objet_mouvement_couleur_des1 from './objet_mouvement_couleur_des1.gif';
import objet_mouvement_couleur_des2 from './objet_mouvement_couleur_des2.gif';
import objet_mouvement_couleur_dessinateur from './objet_mouvement_couleur_dessinateur.gif';
import objet_mouvement_couleur_diamant1 from './objet_mouvement_couleur_diamant1.gif';
import objet_mouvement_couleur_diamant2 from './objet_mouvement_couleur_diamant2.gif';
import objet_mouvement_couleur_diamant3 from './objet_mouvement_couleur_diamant3.gif';
import objet_mouvement_couleur_drapeaueurope from './objet_mouvement_couleur_drapeaueurope.gif';
import objet_mouvement_couleur_elephantelmer from './objet_mouvement_couleur_elephantelmer.gif';
import objet_mouvement_couleur_engrenage from './objet_mouvement_couleur_engrenage.gif';
import objet_mouvement_couleur_etoile from './objet_mouvement_couleur_etoile.gif';
import objet_mouvement_couleur_etoiledemer from './objet_mouvement_couleur_etoiledemer.gif';
import objet_mouvement_couleur_explosion from './objet_mouvement_couleur_explosion.gif';
import objet_mouvement_couleur_extraterrestrerayures1 from './objet_mouvement_couleur_extraterrestrerayures1.gif';
import objet_mouvement_couleur_extraterrestrerayures2 from './objet_mouvement_couleur_extraterrestrerayures2.gif';
import objet_mouvement_couleur_fee from './objet_mouvement_couleur_fee.gif';
import objet_mouvement_couleur_feudecamp1 from './objet_mouvement_couleur_feudecamp1.gif';
import objet_mouvement_couleur_feudecamp2 from './objet_mouvement_couleur_feudecamp2.gif';
import objet_mouvement_couleur_fleur1 from './objet_mouvement_couleur_fleur1.gif';
import objet_mouvement_couleur_fleur2 from './objet_mouvement_couleur_fleur2.gif';
import objet_mouvement_couleur_fleur3 from './objet_mouvement_couleur_fleur3.gif';
import objet_mouvement_couleur_fleur4 from './objet_mouvement_couleur_fleur4.gif';
import objet_mouvement_couleur_fleur5 from './objet_mouvement_couleur_fleur5.gif';
import objet_mouvement_couleur_fourmipomme from './objet_mouvement_couleur_fourmipomme.gif';
import objet_mouvement_couleur_fraise1 from './objet_mouvement_couleur_fraise1.gif';
import objet_mouvement_couleur_fraise2 from './objet_mouvement_couleur_fraise2.gif';
import objet_mouvement_couleur_gateauanniversaire from './objet_mouvement_couleur_gateauanniversaire.gif';
import objet_mouvement_couleur_guepard from './objet_mouvement_couleur_guepard.gif';
import objet_mouvement_couleur_hippocampe from './objet_mouvement_couleur_hippocampe.gif';
import objet_mouvement_couleur_huit from './objet_mouvement_couleur_huit.gif';
import objet_mouvement_couleur_lampetorche from './objet_mouvement_couleur_lampetorche.gif';
import objet_mouvement_couleur_lunettes from './objet_mouvement_couleur_lunettes.gif';
import objet_mouvement_couleur_maindroite from './objet_mouvement_couleur_maindroite.gif';
import objet_mouvement_couleur_maingauche from './objet_mouvement_couleur_maingauche.gif';
import objet_mouvement_couleur_montgolfiere from './objet_mouvement_couleur_montgolfiere.gif';
import objet_mouvement_couleur_musiqueboite from './objet_mouvement_couleur_musiqueboite.gif';
import objet_mouvement_couleur_musiquenote from './objet_mouvement_couleur_musiquenote.gif';
import objet_mouvement_couleur_neuf from './objet_mouvement_couleur_neuf.gif';
import objet_mouvement_couleur_oeufboite from './objet_mouvement_couleur_oeufboite.gif';
import objet_mouvement_couleur_oeufcasse from './objet_mouvement_couleur_oeufcasse.gif';
import objet_mouvement_couleur_oiseau1 from './objet_mouvement_couleur_oiseau1.gif';
import objet_mouvement_couleur_oiseau2 from './objet_mouvement_couleur_oiseau2.gif';
import objet_mouvement_couleur_oiseau3 from './objet_mouvement_couleur_oiseau3.gif';
import objet_mouvement_couleur_orangetranche from './objet_mouvement_couleur_orangetranche.gif';
import objet_mouvement_couleur_panneauvache from './objet_mouvement_couleur_panneauvache.gif';
import objet_mouvement_couleur_panthererose from './objet_mouvement_couleur_panthererose.gif';
import objet_mouvement_couleur_papillon1 from './objet_mouvement_couleur_papillon1.gif';
import objet_mouvement_couleur_papillon2 from './objet_mouvement_couleur_papillon2.gif';
import objet_mouvement_couleur_papillon3 from './objet_mouvement_couleur_papillon3.gif';
import objet_mouvement_couleur_papillon4 from './objet_mouvement_couleur_papillon4.gif';
import objet_mouvement_couleur_papillon5 from './objet_mouvement_couleur_papillon5.gif';
import objet_mouvement_couleur_papillon6 from './objet_mouvement_couleur_papillon6.gif';
import objet_mouvement_couleur_piece1 from './objet_mouvement_couleur_piece1.gif';
import objet_mouvement_couleur_piece2 from './objet_mouvement_couleur_piece2.gif';
import objet_mouvement_couleur_pinceau from './objet_mouvement_couleur_pinceau.gif';
import objet_mouvement_couleur_pingouin from './objet_mouvement_couleur_pingouin.gif';
import objet_mouvement_couleur_planeteterre from './objet_mouvement_couleur_planeteterre.gif';
import objet_mouvement_couleur_poires from './objet_mouvement_couleur_poires.gif';
import objet_mouvement_couleur_poisson1 from './objet_mouvement_couleur_poisson1.gif';
import objet_mouvement_couleur_poisson2 from './objet_mouvement_couleur_poisson2.gif';
import objet_mouvement_couleur_poisson3 from './objet_mouvement_couleur_poisson3.gif';
import objet_mouvement_couleur_poisson4 from './objet_mouvement_couleur_poisson4.gif';
import objet_mouvement_couleur_pomme from './objet_mouvement_couleur_pomme.gif';
import objet_mouvement_couleur_projecteurs from './objet_mouvement_couleur_projecteurs.gif';
import objet_mouvement_couleur_punaise from './objet_mouvement_couleur_punaise.gif';
import objet_mouvement_couleur_radar1 from './objet_mouvement_couleur_radar1.gif';
import objet_mouvement_couleur_radar2 from './objet_mouvement_couleur_radar2.gif';
import objet_mouvement_couleur_raisin from './objet_mouvement_couleur_raisin.gif';
import objet_mouvement_couleur_regle from './objet_mouvement_couleur_regle.gif';
import objet_mouvement_couleur_repertoire from './objet_mouvement_couleur_repertoire.gif';
import objet_mouvement_couleur_repertoire2 from './objet_mouvement_couleur_repertoire2.gif';
import objet_mouvement_couleur_reveil from './objet_mouvement_couleur_reveil.gif';
import objet_mouvement_couleur_smiley from './objet_mouvement_couleur_smiley.gif';
import objet_mouvement_couleur_soleil from './objet_mouvement_couleur_soleil.gif';
import objet_mouvement_couleur_soucoupe from './objet_mouvement_couleur_soucoupe.gif';
import objet_mouvement_couleur_tigre from './objet_mouvement_couleur_tigre.gif';
import objet_mouvement_couleur_torche from './objet_mouvement_couleur_torche.gif';
import objet_mouvement_couleur_toupie from './objet_mouvement_couleur_toupie.gif';
import objet_mouvement_couleur_trésor from './objet_mouvement_couleur_trésor.gif';
import objet_mouvement_couleur_voiture1 from './objet_mouvement_couleur_voiture1.gif';
import objet_mouvement_couleur_voiture2 from './objet_mouvement_couleur_voiture2.gif';
import objet_mouvement_nb_ballegolf from './objet_mouvement_nb_ballegolf.gif';
import objet_mouvement_nb_ballonfoot1 from './objet_mouvement_nb_ballonfoot1.gif';
import objet_mouvement_nb_ballonfoot2 from './objet_mouvement_nb_ballonfoot2.gif';
import objet_mouvement_nb_orque from './objet_mouvement_nb_orque.gif';
import objet_mouvement_nb_singe from './objet_mouvement_nb_singe.gif';

const catalog = {
  geometrie_diagonal1_blanc_trait,
  geometrie_diagonal1_bleu_trait,
  geometrie_diagonal1_jaune_trait,
  geometrie_diagonal1_noir_trait,
  geometrie_diagonal1_orange_trait,
  geometrie_diagonal1_rose_trait,
  geometrie_diagonal1_rouge_trait,
  geometrie_diagonal1_vert_trait,
  geometrie_diagonal1_violet_trait,
  geometrie_diagonal2_blanc_trait,
  geometrie_diagonal2_bleu_trait,
  geometrie_diagonal2_jaune_trait,
  geometrie_diagonal2_noir_trait,
  geometrie_diagonal2_orange_trait,
  geometrie_diagonal2_rose_trait,
  geometrie_diagonal2_rouge_trait,
  geometrie_diagonal2_vert_trait,
  geometrie_diagonal2_violet_trait,
  geometrie_horizontal_blanc_trait,
  geometrie_horizontal_bleu_trait,
  geometrie_horizontal_jaune_trait,
  geometrie_horizontal_noir_trait,
  geometrie_horizontal_orange_trait,
  geometrie_horizontal_rose_trait,
  geometrie_horizontal_rouge_trait,
  geometrie_horizontal_vert_trait,
  geometrie_horizontal_violet_trait,
  geometrie_plein_blanc_carre,
  geometrie_plein_blanc_etoile,
  geometrie_plein_blanc_losange,
  geometrie_plein_blanc_rond,
  geometrie_plein_blanc_triangle,
  geometrie_plein_bleu_carre,
  geometrie_plein_bleu_etoile,
  geometrie_plein_bleu_losange,
  geometrie_plein_bleu_rond,
  geometrie_plein_bleu_triangle,
  geometrie_plein_jaune_carre,
  geometrie_plein_jaune_etoile,
  geometrie_plein_jaune_losange,
  geometrie_plein_jaune_rond,
  geometrie_plein_jaune_triangle,
  geometrie_plein_noir_carre,
  geometrie_plein_noir_etoile,
  geometrie_plein_noir_losange,
  geometrie_plein_noir_rond,
  geometrie_plein_noir_triangle,
  geometrie_plein_orange_carre,
  geometrie_plein_orange_etoile,
  geometrie_plein_orange_losange,
  geometrie_plein_orange_rond,
  geometrie_plein_orange_triangle,
  geometrie_plein_rose_carre,
  geometrie_plein_rose_etoile,
  geometrie_plein_rose_losange,
  geometrie_plein_rose_rond,
  geometrie_plein_rose_triangle,
  geometrie_plein_rouge_carre,
  geometrie_plein_rouge_etoile,
  geometrie_plein_rouge_losange,
  geometrie_plein_rouge_rond,
  geometrie_plein_rouge_triangle,
  geometrie_plein_vert_carre,
  geometrie_plein_vert_etoile,
  geometrie_plein_vert_losange,
  geometrie_plein_vert_rond,
  geometrie_plein_vert_triangle,
  geometrie_plein_violet_carre,
  geometrie_plein_violet_etoile,
  geometrie_plein_violet_losange,
  geometrie_plein_violet_rond,
  geometrie_plein_violet_triangle,
  geometrie_vertical_blanc_trait,
  geometrie_vertical_bleu_trait,
  geometrie_vertical_jaune_trait,
  geometrie_vertical_noir_trait,
  geometrie_vertical_orange_trait,
  geometrie_vertical_rose_trait,
  geometrie_vertical_rouge_trait,
  geometrie_vertical_vert_trait,
  geometrie_vertical_violet_trait,
  geometrie_vide_blanc_etoile,
  geometrie_vide_blanc_carre,
  geometrie_vide_blanc_losange,
  geometrie_vide_blanc_rond,
  geometrie_vide_blanc_soleil,
  geometrie_vide_blanc_triangle,
  geometrie_vide_bleu_carre,
  geometrie_vide_bleu_etoile,
  geometrie_vide_bleu_losange,
  geometrie_vide_bleu_rond,
  geometrie_vide_bleu_soleil,
  geometrie_vide_bleu_triangle,
  geometrie_vide_jaune_carre,
  geometrie_vide_jaune_etoile,
  geometrie_vide_jaune_losange,
  geometrie_vide_jaune_rond,
  geometrie_vide_jaune_soleil,
  geometrie_vide_jaune_triangle,
  geometrie_vide_noir_carre,
  geometrie_vide_noir_etoile,
  geometrie_vide_noir_losange,
  geometrie_vide_noir_rond,
  geometrie_vide_noir_soleil,
  geometrie_vide_noir_triangle,
  geometrie_vide_orange_carre,
  geometrie_vide_orange_etoile,
  geometrie_vide_orange_losange,
  geometrie_vide_orange_rond,
  geometrie_vide_orange_soleil,
  geometrie_vide_orange_triangle,
  geometrie_vide_rose_carre,
  geometrie_vide_rose_etoile,
  geometrie_vide_rose_losange,
  geometrie_vide_rose_rond,
  geometrie_vide_rose_soleil,
  geometrie_vide_rose_triangle,
  geometrie_vide_rouge_carre,
  geometrie_vide_rouge_etoile,
  geometrie_vide_rouge_losange,
  geometrie_vide_rouge_rond,
  geometrie_vide_rouge_soleil,
  geometrie_vide_rouge_triangle,
  geometrie_vide_vert_carre,
  geometrie_vide_vert_etoile,
  geometrie_vide_vert_losange,
  geometrie_vide_vert_rond,
  geometrie_vide_vert_soleil,
  geometrie_vide_vert_triangle,
  geometrie_vide_violet_carre,
  geometrie_vide_violet_etoile,
  geometrie_vide_violet_losange,
  geometrie_vide_violet_rond,
  geometrie_vide_violet_soleil,
  geometrie_vide_violet_triangle,
  objet_fixe_couleur_abeille,
  objet_fixe_couleur_agneau,
  objet_fixe_couleur_altere,
  objet_fixe_couleur_ananas,
  objet_fixe_couleur_ananaslunettes,
  objet_fixe_couleur_appareilphoto,
  objet_fixe_couleur_asdepique,
  objet_fixe_couleur_badminton,
  objet_fixe_couleur_baleine,
  objet_fixe_couleur_ballebaseball,
  objet_fixe_couleur_balletennis,
  objet_fixe_couleur_ballonbasket,
  objet_fixe_couleur_biscuit1,
  objet_fixe_couleur_biscuit2,
  objet_fixe_couleur_cartes,
  objet_fixe_couleur_casquemoto,
  objet_fixe_couleur_chapeaupaille,
  objet_fixe_couleur_chat,
  objet_fixe_couleur_chaussuresport,
  objet_fixe_couleur_chevreau,
  objet_fixe_couleur_chientete,
  objet_fixe_couleur_citron,
  objet_fixe_couleur_coeur,
  objet_fixe_couleur_croissant,
  objet_fixe_couleur_dragon,
  objet_fixe_couleur_etoiledemer,
  objet_fixe_couleur_evantail,
  objet_fixe_couleur_fleur,
  objet_fixe_couleur_fleurscerisier,
  objet_fixe_couleur_fraise,
  objet_fixe_couleur_gantboxe,
  objet_fixe_couleur_grenouille,
  objet_fixe_couleur_jeuenfant,
  objet_fixe_couleur_kiwi,
  objet_fixe_couleur_lion,
  objet_fixe_couleur_maillotbain,
  objet_fixe_couleur_maincle,
  objet_fixe_couleur_manchot,
  objet_fixe_couleur_manette,
  objet_fixe_couleur_minion,
  objet_fixe_couleur_monstre1,
  objet_fixe_couleur_monstre2,
  objet_fixe_couleur_mouton,
  objet_fixe_couleur_oeil,
  objet_fixe_couleur_orange,
  objet_fixe_couleur_ourstete,
  objet_fixe_couleur_palmier,
  objet_fixe_couleur_panneauparis,
  objet_fixe_couleur_papillon,
  objet_fixe_couleur_parasol,
  objet_fixe_couleur_perroquet,
  objet_fixe_couleur_pieuvre,
  objet_fixe_couleur_plantepot,
  objet_fixe_couleur_raquette,
  objet_fixe_couleur_renard,
  objet_fixe_couleur_rougealevres,
  objet_fixe_couleur_seau,
  objet_fixe_couleur_serpent,
  objet_fixe_couleur_short,
  objet_fixe_couleur_television,
  objet_fixe_couleur_tongs,
  objet_fixe_couleur_tortue,
  objet_fixe_couleur_vache,
  objet_fixe_couleur_voiture,
  objet_fixe_nb_avion,
  objet_fixe_nb_baguettemagique,
  objet_fixe_nb_chat,
  objet_fixe_nb_drapeau,
  objet_fixe_noir_empreintepatte,
  objet_fixe_nb_fusee,
  objet_fixe_nb_loup,
  objet_fixe_nb_marguerite,
  objet_fixe_nb_montagnes,
  objet_fixe_nb_nuage,
  objet_fixe_nb_nuage2,
  objet_fixe_nb_nuagelunettes,
  objet_fixe_nb_robinet,
  objet_mouvement_couleur_abeilledessus,
  objet_mouvement_couleur_abeillefleur1,
  objet_mouvement_couleur_abeillefleur2,
  objet_mouvement_couleur_abeillemiel,
  objet_mouvement_couleur_abeilleruche,
  objet_mouvement_couleur_abeillevol,
  objet_mouvement_couleur_ampoule,
  objet_mouvement_couleur_antenne,
  objet_mouvement_couleur_antilope,
  objet_mouvement_couleur_appareilphoto1,
  objet_mouvement_couleur_appareilphoto2,
  objet_mouvement_couleur_appareilphoto3,
  objet_mouvement_couleur_arobase,
  objet_mouvement_couleur_asterisque1,
  objet_mouvement_couleur_asterisque2,
  objet_mouvement_couleur_ballon,
  objet_mouvement_couleur_ballonbasket1,
  objet_mouvement_couleur_ballonbasket2,
  objet_mouvement_couleur_bananes,
  objet_mouvement_couleur_bananier,
  objet_mouvement_couleur_bateau1,
  objet_mouvement_couleur_bateau2,
  objet_mouvement_couleur_bateau3,
  objet_mouvement_couleur_bonhommeneige,
  objet_mouvement_couleur_bourdon,
  objet_mouvement_couleur_cactus,
  objet_mouvement_couleur_capitaine,
  objet_mouvement_couleur_cartes,
  objet_mouvement_couleur_cd1,
  objet_mouvement_couleur_cd2,
  objet_mouvement_couleur_cd3,
  objet_mouvement_couleur_champignons,
  objet_mouvement_couleur_chauvesouris,
  objet_mouvement_couleur_cheval,
  objet_mouvement_couleur_chien,
  objet_mouvement_couleur_ciseaux,
  objet_mouvement_couleur_citron,
  objet_mouvement_couleur_citrouille,
  objet_mouvement_couleur_cle,
  objet_mouvement_couleur_coq,
  objet_mouvement_couleur_coquille,
  objet_mouvement_couleur_cornetglaces,
  objet_mouvement_couleur_crabe,
  objet_mouvement_couleur_crayons1,
  objet_mouvement_couleur_crayons2,
  objet_mouvement_couleur_crayons3,
  objet_mouvement_couleur_cygne,
  objet_mouvement_couleur_danse,
  objet_mouvement_couleur_des1,
  objet_mouvement_couleur_des2,
  objet_mouvement_couleur_dessinateur,
  objet_mouvement_couleur_diamant1,
  objet_mouvement_couleur_diamant2,
  objet_mouvement_couleur_diamant3,
  objet_mouvement_couleur_drapeaueurope,
  objet_mouvement_couleur_elephantelmer,
  objet_mouvement_couleur_engrenage,
  objet_mouvement_couleur_etoile,
  objet_mouvement_couleur_etoiledemer,
  objet_mouvement_couleur_explosion,
  objet_mouvement_couleur_extraterrestrerayures1,
  objet_mouvement_couleur_extraterrestrerayures2,
  objet_mouvement_couleur_fee,
  objet_mouvement_couleur_feudecamp1,
  objet_mouvement_couleur_feudecamp2,
  objet_mouvement_couleur_fleur1,
  objet_mouvement_couleur_fleur2,
  objet_mouvement_couleur_fleur3,
  objet_mouvement_couleur_fleur4,
  objet_mouvement_couleur_fleur5,
  objet_mouvement_couleur_fourmipomme,
  objet_mouvement_couleur_fraise1,
  objet_mouvement_couleur_fraise2,
  objet_mouvement_couleur_gateauanniversaire,
  objet_mouvement_couleur_guepard,
  objet_mouvement_couleur_hippocampe,
  objet_mouvement_couleur_huit,
  objet_mouvement_couleur_lampetorche,
  objet_mouvement_couleur_lunettes,
  objet_mouvement_couleur_maindroite,
  objet_mouvement_couleur_maingauche,
  objet_mouvement_couleur_montgolfiere,
  objet_mouvement_couleur_musiqueboite,
  objet_mouvement_couleur_musiquenote,
  objet_mouvement_couleur_neuf,
  objet_mouvement_couleur_oeufboite,
  objet_mouvement_couleur_oeufcasse,
  objet_mouvement_couleur_oiseau1,
  objet_mouvement_couleur_oiseau2,
  objet_mouvement_couleur_oiseau3,
  objet_mouvement_couleur_orangetranche,
  objet_mouvement_couleur_panneauvache,
  objet_mouvement_couleur_panthererose,
  objet_mouvement_couleur_papillon1,
  objet_mouvement_couleur_papillon2,
  objet_mouvement_couleur_papillon3,
  objet_mouvement_couleur_papillon4,
  objet_mouvement_couleur_papillon5,
  objet_mouvement_couleur_papillon6,
  objet_mouvement_couleur_piece1,
  objet_mouvement_couleur_piece2,
  objet_mouvement_couleur_pinceau,
  objet_mouvement_couleur_pingouin,
  objet_mouvement_couleur_planeteterre,
  objet_mouvement_couleur_poires,
  objet_mouvement_couleur_poisson1,
  objet_mouvement_couleur_poisson2,
  objet_mouvement_couleur_poisson3,
  objet_mouvement_couleur_poisson4,
  objet_mouvement_couleur_pomme,
  objet_mouvement_couleur_projecteurs,
  objet_mouvement_couleur_punaise,
  objet_mouvement_couleur_radar1,
  objet_mouvement_couleur_radar2,
  objet_mouvement_couleur_raisin,
  objet_mouvement_couleur_regle,
  objet_mouvement_couleur_repertoire,
  objet_mouvement_couleur_repertoire2,
  objet_mouvement_couleur_reveil,
  objet_mouvement_couleur_smiley,
  objet_mouvement_couleur_soleil,
  objet_mouvement_couleur_soucoupe,
  objet_mouvement_couleur_tigre,
  objet_mouvement_couleur_torche,
  objet_mouvement_couleur_toupie,
  objet_mouvement_couleur_trésor,
  objet_mouvement_couleur_voiture1,
  objet_mouvement_couleur_voiture2,
  objet_mouvement_nb_ballegolf,
  objet_mouvement_nb_ballonfoot1,
  objet_mouvement_nb_ballonfoot2,
  objet_mouvement_nb_orque,
  objet_mouvement_nb_singe,
} as const;

export default catalog; // Record<'nom_normalise', string>